import config from '../configs/layoutConfig.json'
import parseQueryString from './parseQueryString.js'

const layoutQueryStringParameterKey = 'sf_l'

const { STAGE } = process.env

const getAppLayout = hostname => {
  const queryString = parseQueryString(window.location.search)
  let layout = queryString[layoutQueryStringParameterKey]
  const configLayouts = Object.keys(config)

  if (layout !== 'default' && !configLayouts.includes(layout)) {
    layout = 'default'
  }

  if (layout !== 'default'
  && configLayouts.includes(layout)
  && STAGE !== 'prod'
  ) {
    return config[layout]
  }

  if (hostname.match(/tiendeo/)) {
    layout = 'tiendeo'
  }

  if (hostname.match(/promoqui/)) {
    layout = 'promoqui'
  }

  if (hostname.match(/volantinofacile/)) {
    layout = 'volantinofacile'
  }

  if (hostname.match(/doveconviene\.it$/)) {
    layout = 'default'
  }

  if (hostname.match(/shopfully/)) {
    layout = 'shopfully'
  }

  if (hostname.match(/broshura/)) {
    layout = 'broshura'
  }

  if (hostname.match(/wogibtswas/)) {
    layout = 'wogibtswas'
  }

  if (hostname.match(/handelsangebote/)) {
    layout = 'handelsangebote'
  }

  if (hostname.match(/prospecto/)) {
    layout = 'prospecto'
  }

  if (hostname.match(/folderscheck/)) {
    layout = 'folderscheck'
  }

  const layoutConfig = config[layout]

  return layoutConfig
}

export default getAppLayout
